<template>
  <PagesPermanentWorksComponent
    :pageData="data"
  />
  <NuxtPage />
</template>

<script setup>
// 1
defineI18nRoute({
  paths: {
    en: '/permanent-works',
    nl: '/permanente-werken'
  }
})

// 2
const queryPath = queryPermanentWorksPage(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

// 3
const nuxtApp = useNuxtApp()
const routeName = computed(() => nuxtApp.$getRouteBaseName())
</script>
